import network from '@/utils/network'

/**
 * Poste un feedback
 * @returns {Promise<>}
 */
export const postFeedback = async (feedback) => {
  const r = await network.post(`/feedback`, { ...feedback })
  return r.data
}
